/**
 * Build sync payload from website's PRODUCTS catalog.
 * Sync adds the actual site products to Supabase (Jewellery + Bags + Traditional & Western).
 */
import { PRODUCTS } from "../data/products";

function slugToCategory(slug) {
  if (!slug) return "Earrings";
  // Traditional & Western
  if (slug.startsWith("t-")) return "Traditional Wear";
  if (slug.startsWith("w-")) return "Western Wear";
  // Bags
  if (slug.startsWith("ed-")) return "Everyday Essentials";
  if (slug.startsWith("pt-")) return "Party & Evening Bags";
  if (slug.startsWith("lx-")) return "Luxury Collection";
  // Jewellery - sub-sub categories first (more specific)
  if (slug.startsWith("hoop-")) return "Hoops";
  if (slug.startsWith("monalisa-")) return "Monalisa";
  if (slug.startsWith("stud-")) return "Studs";
  if (slug.startsWith("necklace-pendant-")) return "Pendant Necklaces";
  if (slug.startsWith("choker-")) return "Choker Necklaces";
  if (slug.startsWith("ad-gold-") || slug.startsWith("ad-silver-")) return "American Diamond Stone Necklaces";
  if (slug.startsWith("cz-") || slug.startsWith("ad-circle")) return "CZ Stone Necklaces";
  if (slug.startsWith("matching-") || slug.startsWith("n-set-")) return "Matching Necklace + Earrings Sets";
  // Jewellery - Bracelets sub-sub
  if (slug.startsWith("gold-bracelet-")) return "Gold Bracelets";
  if (slug.startsWith("gold-kada-")) return "Gold Kada";
  if (slug.startsWith("cuff-bracelet-")) return "Cuff Bracelets";
  // Jewellery - Bangles sub-sub
  if (slug.startsWith("bangle-anti-")) return "Anti-Tarnish Gold Plated Bangles";
  if (slug.startsWith("bangle-brass-")) return "Brass Gold Bangles";
  if (slug.startsWith("bangle-fancy-")) return "Unique Fancy Bangles";
  // Jewellery - sub-categories (Rings has no sub-sub)
  if (slug.startsWith("ring-")) return "Rings";
  return "Earrings";
}

/**
 * Get products from site catalog for sync.
 * Each item: { name, description, price, stock_quantity, category, image_url }
 * image_url uses the first image from the build (CRA outputs to /static/media/)
 */
export function getSiteProductsForSync() {
  // Bags & Traditional excluded — client will add via Dashboard later
  return Object.entries(PRODUCTS).map(([slug, p]) => {
    const img = p.images?.[0];
    const imageUrl = typeof img === "string" ? img : "";
    return {
      name: p.title,
      description: p.description || "",
      price: Number(p.offerPrice) || 0,
      stock_quantity: 50,
      category: slugToCategory(slug),
      image_url: imageUrl || null,
    };
  });
}
